import React, { useEffect, useRef, useState } from 'react';

interface VerticalAdProps {
    adSlot: string;
    width?: number;
    height?: number;
    className?: string;
}

export default function VerticalAd({
                                       adSlot,
                                       width = 120,
                                       height = 600,
                                       className = ''
                                   }: VerticalAdProps) {
    const wrapperCls = useRef('ad-wrap-' + Math.random().toString(36).substr(2, 8));
    const [blocked, setBlocked] = useState(false);
    const AD_CLIENT = 'ca-pub-6425578398196260';

    useEffect(() => {
        try {
            // @ts-ignore
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            setTimeout(() => {
                const ins = document.querySelector(`.${wrapperCls.current} ins.adsbygoogle`);
                if (!ins || (ins as HTMLElement).offsetHeight === 0) {
                    setBlocked(true);
                }
            }, 500);
        } catch {
            setBlocked(true);
        }
    }, []);

    return (
        <div
            className={`${wrapperCls.current} ${className}`}
            style={{ width, height, margin: '0 auto' }}
        >
            {blocked ? (
                <div style={{
                    width, height,
                    background: '#eee', color: '#555',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, textAlign: 'center'
                }}>
                    Please disable adblock to support us
                </div>
            ) : (
                <ins
                    className="adsbygoogle"
                    style={{ display: 'inline-block', width, height }}
                    data-ad-client={AD_CLIENT}
                    data-ad-slot={adSlot}
                    data-ad-format="auto"
                ></ins>
            )}
        </div>
    );
}
